/* Product page: swipeable gallery, zoomable lightbox, styles, quantity, matching kit, sticky buy bar, how-to videos. */
(() => {
  'use strict';
  const H = window.HOP || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ok = () => (H.motionOk ? H.motionOk() : true);
  const money = (c) => (H.money ? H.money(c) : `$${(c / 100).toFixed(2)}`);
  const EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  function gallery(root) {
    const track = $('[data-pdp-track]', root); if (!track) return;
    const slides = $$('.pdp-slide', track), thumbs = $$('[data-gallery-index]', root), count = $('[data-gallery-count]', root);
    let cur = 0;
    const mark = (i) => {
      cur = i; if (count) count.textContent = `${i + 1} / ${slides.length}`;
      thumbs.forEach((b, k) => { b.classList.toggle('is-current', k === i); b.setAttribute('aria-pressed', String(k === i)); });
      slides.forEach((s, k) => s.classList.toggle('is-current', k === i));
    };
    const go = (i) => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: ok() ? 'smooth' : 'auto' }); mark(i); };
    if (slides.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); }), { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-gallery-index]'); if (t) { go(Number(t.dataset.galleryIndex)); return; }
      if (e.target.closest('[data-gallery-prev]')) go(cur - 1);
      if (e.target.closest('[data-gallery-next]')) go(cur + 1);
      const z = e.target.closest('[data-zoom]'); if (z) openLightbox(Number(z.dataset.zoom), z);
      if (e.target.closest('[data-zoom-current]')) openLightbox(cur, e.target.closest('[data-zoom-current]'));
    });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    // desktop: the photo follows the pointer a little, like holding the box
    if (ok() && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const stage = $('.pdp-image-stage', root);
      stage.addEventListener('pointermove', (e) => { const r = stage.getBoundingClientRect(); stage.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`); stage.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`); stage.classList.add('is-hover'); });
      stage.addEventListener('pointerleave', () => stage.classList.remove('is-hover'));
    }
    root._go = go;

    /* lightbox with pointer zoom and swipe */
    const box = $('[data-lightbox]', root), big = box && $('[data-lightbox-img]', box), lcount = box && $('[data-lightbox-count]', box);
    let li = 0;
    const show = (i, dir = 0) => {
      li = (i + slides.length) % slides.length; const src = slides[li].dataset.full; if (!big) return;
      big.classList.remove('is-zoomed');
      const swap = () => { big.src = src; if (lcount) lcount.textContent = `${li + 1} / ${slides.length}`; };
      if (dir && ok()) big.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateX(${dir * -30}px)` }], { duration: 140 }).finished.then(() => { swap(); big.animate([{ opacity: 0, transform: `translateX(${dir * 30}px)` }, { opacity: 1, transform: 'none' }], { duration: 300, easing: EASE }); });
      else swap();
    };
    function openLightbox(i, trigger) { if (!box) return; show(i); H.openDialog ? H.openDialog(box, trigger) : box.showModal(); }
    if (box) {
      box.addEventListener('click', (e) => {
        if (e.target.closest('[data-lightbox-prev]')) show(li - 1, -1);
        if (e.target.closest('[data-lightbox-next]')) show(li + 1, 1);
        if (e.target === big) { big.classList.toggle('is-zoomed'); }
      });
      box.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') { e.preventDefault(); show(li - 1, -1); } if (e.key === 'ArrowRight') { e.preventDefault(); show(li + 1, 1); } });
      big.addEventListener('pointermove', (e) => { if (!big.classList.contains('is-zoomed')) return; const r = big.getBoundingClientRect(); big.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
      let sx = null;
      big.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') sx = e.clientX; });
      big.addEventListener('pointerup', (e) => { if (sx === null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) show(li + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); });
    }
  }

  function buyBox(root) {
    const form = $('[data-pdp-form]', root); if (!form) return;
    let data; try { data = JSON.parse($('[data-pdp-json]', root).textContent); } catch (e) { data = { variants: [] }; }
    const idEl = $('[data-pdp-variant]', form), qty = $('#pdp-quantity', form), add = $('[data-pdp-add]', form), pair = $('[data-pdp-pair]', form), status = $('#pdp-order-status', form);
    const sticky = $('[data-pdp-sticky]', root), sPrice = $('[data-pdp-sticky-price]', root), sAdd = $('[data-pdp-sticky-add]', root), priceBox = $('[data-pdp-price]', root);
    let v = data.variants.find((x) => String(x.id) === idEl.value) || data.variants[0];
    const q = () => { let n = parseInt(qty.value, 10); if (!Number.isFinite(n) || n < 1) n = 1; n = Math.min(99, n); qty.value = n; $('[data-qty-minus]', form).disabled = n <= 1; $('[data-qty-plus]', form).disabled = n >= 99; return n; };
    const total = () => (v ? v.price : 0) * q() + (pair && pair.checked ? Number(pair.dataset.pairPrice || 0) * q() : 0);
    const paint = (bump) => {
      if (!v) return; const both = pair && pair.checked;
      $('[data-pdp-qty-label]', form).textContent = both ? 'How many matching sets?' : 'How many kits?';
      if (v.available) {
        add.disabled = false; add.innerHTML = `<span data-pdp-add-label>${both ? 'Add both to party bag' : 'Add to party bag'}</span><span data-pdp-add-total>${money(total())} →</span>`;
        if (sAdd) { sAdd.disabled = false; sAdd.textContent = both ? 'Add both →' : 'Add to bag →'; }
      } else { add.disabled = true; add.textContent = 'Currently sold out'; if (sAdd) { sAdd.disabled = true; sAdd.textContent = 'Sold out'; } }
      if (sPrice) sPrice.textContent = money(total());
      if (bump && ok()) $('[data-pdp-add-total]', add)?.animate([{ transform: 'translateY(6px)', opacity: 0.2 }, { transform: 'none', opacity: 1 }], { duration: 360, easing: EASE });
    };
    form.addEventListener('click', (e) => {
      const m = e.target.closest('[data-qty-minus]'), p = e.target.closest('[data-qty-plus]');
      if (m || p) { qty.value = q() + (p ? 1 : -1); q(); paint(true); }
    });
    qty.addEventListener('change', () => paint(true));
    pair && pair.addEventListener('change', () => { paint(true); if (pair.checked && ok()) pair.closest('label').animate([{ transform: 'scale(1)' }, { transform: 'scale(1.02)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'cubic-bezier(0.34,1.56,0.64,1)' }); });
    // styles
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-pdp-option]')) return;
      const picked = $$('[data-pdp-option]:checked', form).map((r) => r.value);
      const nv = data.variants.find((x) => x.options.every((o, i) => o === picked[i])); if (!nv) return;
      v = nv; idEl.value = nv.id;
      $$('[data-pdp-option-label]', form).forEach((l, i) => (l.textContent = picked[i]));
      if (priceBox) { const strong = $('strong', priceBox); strong.textContent = money(nv.price); if (ok()) strong.animate([{ opacity: 0.3, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE }); }
      if (nv.image != null && root._go) root._go(nv.image);
      const u = new URL(location.href); u.searchParams.set('variant', nv.id); history.replaceState(null, '', u);
      paint();
    });
    const buy = (trigger) => {
      if (!v || !v.available) return;
      const items = [{ id: v.id, quantity: q() }]; if (pair && pair.checked) items.push({ id: Number(pair.value), quantity: q() });
      if (!H.addToCart) { form.submit(); return; }
      H.addToCart(items, trigger, { party: items.length > 1, message: `${data.name} is in your bag` }).then(() => { status.textContent = items.length > 1 ? 'Both matching kits are in your bag.' : 'Added to your party bag.'; }).catch(() => {});
    };
    form.addEventListener('submit', (e) => { if (!H.addToCart) return; e.preventDefault(); buy(add); });
    sAdd && sAdd.addEventListener('click', () => buy(sAdd));
    // sticky bar on phones once the buy button scrolls away
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); if (sAdd) sAdd.tabIndex = on ? 0 : -1;
      }).observe(add);
    }
    q(); paint();
    // the buy column settles in once
    if (ok()) [...$('.pdp-buy', root).children].forEach((c, i) => c.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 640, delay: 80 + Math.min(i, 9) * 45, easing: EASE, fill: 'backwards' }));
  }

  /* how-to video player: thumbnails until someone presses play */
  function guide(sec) {
    const box = $('[data-guide-video]', sec); if (!box) return;
    const play = (id, title) => {
      box.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1" title="${title ? title.replace(/"/g, '&quot;') : 'How-to video'}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen loading="lazy"></iframe>`;
    };
    sec.addEventListener('click', (e) => {
      const p = e.target.closest('[data-guide-play]'); if (p) { play(p.dataset.guidePlay, p.getAttribute('aria-label')); return; }
      const s = e.target.closest('[data-guide-step]');
      if (s) {
        $$('[data-guide-step]', sec).forEach((b) => b.removeAttribute('aria-current')); s.setAttribute('aria-current', 'step');
        play(s.dataset.guideStep, s.dataset.guideTitle);
        try { localStorage.setItem(`hop-guide-${location.pathname}`, s.dataset.guideStep); } catch (err) { /* fine */ }
        if (innerWidth < 760) box.scrollIntoView({ behavior: ok() ? 'smooth' : 'auto', block: 'center' });
      }
    });
  }

  /* Shopify's own related picks, when turned on */
  function recs(sec) {
    const url = sec.dataset.recs; if (!url) return;
    const load = () => fetch(url).then((r) => r.text()).then((html) => {
      const grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs-grid]');
      if (grid && grid.children.length) { $('[data-recs-grid]', sec).innerHTML = grid.innerHTML; H.reveal && H.reveal(sec); }
    }).catch(() => {});
    if (!('IntersectionObserver' in window)) return load();
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' }); io.observe(sec);
  }

  const boot = () => {
    $$('[data-pdp]').forEach((root) => { if (root._pdp) return; root._pdp = 1; gallery(root); buyBox(root); });
    $$('[data-guide]').forEach((s) => { if (!s._g) { s._g = 1; guide(s); } });
    $$('[data-recs]').forEach((s) => { if (!s._r) { s._r = 1; recs(s); } });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
